import { Wrapper, HeadingSection, TopicWrapper, TopicLabel, Topic, FrameWrapper } from "./SpeakingStyle"
import Dialogs from "./01_dialogs/Dialogs"
import Stories from "./02_stories/Stories"
// import { TopicData } from "./TopicsData"
// import { useSelector } from "react-redux"

const Speaking = () => {

    // const currentLesson = useSelector(state => state.lesson.currentLesson)

  return (
    <Wrapper>
      <HeadingSection>
        Speaking
      </HeadingSection>
      {/* {TopicData.filter(val => val.lesson === currentLesson).map((value, index) => (
        <TopicWrapper key={index}>
          <TopicLabel>Topic:&nbsp;</TopicLabel>
          <Topic>{value.topic}`</Topic>
        </TopicWrapper>
      ))} */}
      <FrameWrapper>
        <Dialogs />
        <Stories />
      </FrameWrapper>
    </Wrapper>
  )
}

export default Speaking